<div class="fixed left-0 top-0 w-dvw h-dvh bg-white z-[1111] flex items-center justify-center">
  <!-- <mat-spinner [diameter]="diameter" class="spinner-bg"></mat-spinner> -->
  <mat-spinner [diameter]="diameter"></mat-spinner>
</div>
